import { BaseService } from 'services/baseService';
import { BusinessUnitModel } from 'types/BusinessUnit/BusinessUnitModel';

class BusinessUnitService extends BaseService<BusinessUnitModel> {
  controllerName = 'business-unit';
}

export const businessUnitService = new BusinessUnitService();
